import { Button } from '@cian/ui-kit';
import * as React from 'react';

import { useCallbackButton } from './useCallbackButton';
import { TCallbackOpener } from '../../types/callbackPopup';

interface ILegacyCallBackButtonContainerProps {
  placeType: TCallbackOpener;
}

export function LegacyCallBackButtonContainer({ placeType }: ILegacyCallBackButtonContainerProps) {
  const [isCallbackAvailable, handleCallbackButtonClick] = useCallbackButton(placeType);

  if (!isCallbackAvailable) {
    return null;
  }

  return (
    <Button size="XS" theme="fill_secondary" onClick={handleCallbackButtonClick}>
      Перезвоните мне
    </Button>
  );
}
